import styles from './PopupAddExtMetamask.module.scss'
import { Modal } from 'components/Modal/Modal'
import { Icon } from 'components/Icon/Icon'
import { Button } from 'components/Button/Button'
import { Link } from 'react-router-dom'

type Props = {
    onClose: () => void,
}

export function PopupAddExtMetamask(props: Props) {
    return (
        <Modal onClose={props.onClose}>
            <form className={styles['wrapper']}>
                <div className={styles['saving']}>
                    <Icon name='wallet_big' />
                </div>
                <div>
                    <div className={styles['content']}>
                        <span className={styles['title']}>
                            Your browser doesn't have Metamask
                        </span>
                        <span className={styles['description']}>
                            To create a deposit, you need to
                            <Link to='/' className={styles['link']}> connect your wallet</Link> to the Metamask account.
                            <br />
                            Let's show you how.
                        </span>
                    </div>
                </div>
                <div className={styles['button']}>
                    <Button size='l' type='dark' onClick={props.onClose}>
                        Go on 👉
                    </Button>
                </div>
            </form>
        </Modal>
    )
}

